import { render } from "./TemplateMyCouponsIndexOfPast.vue?vue&type=template&id=6725fc6e"
import script from "./TemplateMyCouponsIndexOfPast.vue?vue&type=script&lang=js"
export * from "./TemplateMyCouponsIndexOfPast.vue?vue&type=script&lang=js"
script.render = render

export default script